const removeFilterValue = (filter, valueToRemove, initialFilterValue) => {
  if (Array.isArray(filter)) {
    return filter.filter(filterValue => filterValue !== valueToRemove);
  }
  return initialFilterValue;
};

export default removeFilterValue;
